export default "__VITE_ASSET__BRuWKjk1__"